import { Button } from 'flowbite-react';
import React, { useRef, useState } from "react";
import { BsInstagram, BsLinkedin, BsTwitter } from "react-icons/bs";
import { FaFacebook, FaRobot } from "react-icons/fa6"; // Added FaRobot for chatbot icon
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useLocation, useNavigate } from "react-router-dom";
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const DigitalMarketing = () => {
  const [selectedCategory, setSelectedCategory] = useState("Advertisements");
  const [fileOption, setFileOption] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showSocialMedia, setShowSocialMedia] = useState(false);
  const [showPost, setShowPost] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [showChatBox, setShowChatBox] = useState(false); // New state for ChatBox visibility
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const mockAuthentication = () => {
    return new Promise((resolve) => {
      setTimeout(() => resolve(true), 1000);
    });
  };

  const handleFileUpload = (file) => {
    if (file) {
      setFileOption(file.name);
      setErrorMessage("");

      const validImageTypes = ["image/jpeg", "image/png", "image/gif"];
      if (validImageTypes.includes(file.type)) {
        setImagePreview(URL.createObjectURL(file));
      } else {
        setErrorMessage("Please upload a valid image file (jpg, png, gif).");
        setImagePreview(null);
      }
    } else {
      setFileOption(null);
      setImagePreview(null);
    }
  };
  
  const location = useLocation();
  const { file } = location.state || {};
  const [editorContent, setEditorContent] = useState("");

  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  const handleSave = () => {
  };

  const handleUploadClick = async () => {
    if (!fileOption) {
      setErrorMessage("Please upload a file first.");
    } else {
      setShowSocialMedia(true);
      setErrorMessage("");
      const isAuthenticated = await mockAuthentication();
      if (isAuthenticated) {
        setShowPost(true);
        setShowSocialMedia(false);
        setShowChatBox(true); // Open the chatbox when the post is shown
      } else {
        setErrorMessage("Authentication failed. Please try again.");
      }
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFileUpload(file);
  };

  const allowDragOver = (e) => {
    e.preventDefault();
  };

  const handleImageDragStart = (e, src) => {
    e.dataTransfer.setData("text/plain", src);
  };

  const renderContent = () => {
    switch (selectedCategory) {
      case "Advertisements":
        return (
          <div className="content-section">
            <p className="text-gray-600">Here are some advertisement samples.</p>
            <div className='flex gap-3'>
            <img
              src="https://via.placeholder.com/150"
              alt="Advertisements"
              className="mb-4"
              draggable="true"
              onDragStart={(e) => handleImageDragStart(e, "Advertisements")}
            />
            <img
              src="https://via.placeholder.com/150"
              alt="Advertisements"
              className="mb-4"
              draggable="true"
              onDragStart={(e) => handleImageDragStart(e, "Advertisements")}
            />
            <img
              src="https://via.placeholder.com/150"
              alt="Advertisements"
              className="mb-4"
              draggable="true"
              onDragStart={(e) => handleImageDragStart(e, "Advertisements")}
            />
            </div>
            

          </div>
        );
      case "Posters":
        return (
          <div className="content-section">
            <p className="text-gray-600">Here are some poster samples.</p>
            <div className='flex gap-3'>
              <img
                src="https://via.placeholder.com/150"
                alt="Posters"
                className="mb-4"
                draggable="true"
                onDragStart={(e) => handleImageDragStart(e, "Posters")}
              />
              <img
                src="https://via.placeholder.com/150"
                alt="Posters"
                className="mb-4"
                draggable="true"
                onDragStart={(e) => handleImageDragStart(e, "Posters")}
              />
              <img
                src="https://via.placeholder.com/150"
                alt="Posters"
                className="mb-4"
                draggable="true"
                onDragStart={(e) => handleImageDragStart(e, "Posters")}
              />
            </div>
          </div>
        );
      case "Trailers":
        return (
          <div className="content-section">
            <p className="text-gray-600">Here are some trailer samples.</p>
            <div className='flex gap-3'>
            <img
              src="https://via.placeholder.com/150"
              alt="Trailers"
              className="mb-4"
              draggable="true"
              onDragStart={(e) => handleImageDragStart(e, "Trailers")}
            />
            <img
              src="https://via.placeholder.com/150"
              alt="Trailers"
              className="mb-4"
              draggable="true"
              onDragStart={(e) => handleImageDragStart(e, "Trailers")}
            />
            <img
              src="https://via.placeholder.com/150"
              alt="Trailers"
              className="mb-4"
              draggable="true"
              onDragStart={(e) => handleImageDragStart(e, "Trailers")}
            />
            </div>
            
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
    <SEO
      title="Digital Marketing for Films"
      description="Promote your film with ProducerBuddy's digital marketing tools. Run paid campaigns, track ROI, and reach global audiences."
      url="https://producerbuddy.pilomation.com/digital-marketing"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div className="flex flex-col items-center justify-center bg-gray-100 p-4 relative">
      <h2 className="font-bold text-center text-2xl mb-4">Promote your work with just a few clicks</h2>

      <div className="max-w-2xl w-full flex flex-col justify-center bg-white rounded-lg shadow-lg p-6">
        <div className="flex justify-center mb-6">
          <button
            className={`mx-2 px-4 py-2 font-semibold rounded-lg ${selectedCategory === "Advertisements" ? "bg-blue-600 text-white" : "bg-gray-300 text-gray-700"}`}
            onClick={() => setSelectedCategory("Advertisements")}
          >
            Advertisements
          </button>
          <button
            className={`mx-2 px-4 py-2 font-semibold rounded-lg ${selectedCategory === "Posters" ? "bg-blue-600 text-white" : "bg-gray-300 text-gray-700"}`}
            onClick={() => setSelectedCategory("Posters")}
          >
            Posters
          </button>
          <button
            className={`mx-2 px-4 py-2 font-semibold rounded-lg ${selectedCategory === "Trailers" ? "bg-blue-600 text-white" : "bg-gray-300 text-gray-700"}`}
            onClick={() => setSelectedCategory("Trailers")}
          >
            Trailers
          </button>
        </div>

        {renderContent()}

        <div
          className="mt-4 border-2 border-dashed border-gray-400 rounded-lg p-6 flex flex-col items-center justify-center bg-gray-50"
          onDrop={handleDrop}
          onDragOver={allowDragOver}
        >
          <p className="text-gray-500 mb-4">Drag & drop files here</p>
          <input
            ref={fileInputRef}
            type="file"
            className="hidden"
            onChange={(e) => handleFileUpload(e.target.files[0])}
          />
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition duration-300"
            onClick={() => fileInputRef.current.click()}
          >
            Upload {selectedCategory} File
          </button>
        </div>

        {fileOption && (
          <div className="mt-4 text-center text-gray-700">
            <p><strong>{fileOption}</strong></p>
            {imagePreview && <img src={imagePreview} alt="Preview" className="mt-4 max-w-xs" />}
          </div>
        )}

        {errorMessage && (
          <div className="mt-4 text-center text-red-500">
            <p>{errorMessage}</p>
          </div>
        )}
        
        {showPost && (
          <div className="max-w-md h-full w-full bg-white rounded-lg shadow-lg p-3 mt-4">
            <h2 className="text-2xl font-bold mb-2 text-gray-700 text-center">Post</h2>
            <ReactQuill theme='snow' value={editorContent} className="h-50  p-3" onChange={handleEditorChange} placeholder='Write something...'/>
            <div className="p-3 mt-4 text-center">
              <Button className="bg-blue-600 text-white px-2 py-1 rounded hover:bg-blue-600 transition duration-300" onClick={handleSave}>
                Save Post
              </Button>
            </div>
          </div>
        )}

        <div className="mt-6">
          <button
            className="w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600 transition duration-300"
            onClick={handleUploadClick}
          >
            Submit {selectedCategory}
          </button>
        </div>

        {showSocialMedia && (
          <div className="mt-6 p-4 bg-white border border-gray-300 rounded-lg shadow-lg">
            <h3 className="text-lg font-semibold mb-4">Share on Social Media</h3>
            <div className="flex justify-center space-x-4">
              <BsTwitter size={32} className="text-blue-500 cursor-pointer" />
              <FaFacebook size={32} className="text-blue-600 cursor-pointer" />
              <BsInstagram size={32} className="text-pink-500 cursor-pointer" />
              <BsLinkedin size={32} className="text-blue-700 cursor-pointer" />
            </div>
          </div>
        )}
      </div>
    </div>
    <div  className=' bg-gray-100 p-4 relative'>
      {/* Chatbot Icon */}
      <div className=" flex justify-end content-end">
        <FaRobot
          size={48}
          className="text-blue-600 cursor-pointer hover:text-blue-800"
          onClick={() => setShowChatBox(!showChatBox)} // Toggle ChatBox visibility
        />
        {/* AI Chatbox */}
      {showChatBox && (
        <div className="flex flex-col  w-80 bg-white border border-gray-300 rounded-lg shadow-lg p-4" style={{right:'20px'}}>
          <h3 className="text-lg font-semibold mb-4">AI Chat</h3>
          <div className="chat-messages h-64 overflow-y-auto mb-4 p-2 bg-gray-100 rounded-lg">
            {/* AI chat messages would go here */}
            <p>Welcome to the AI Chat!</p>
          </div>
          <div className="flex items-center">
            <input
              type="text"
              placeholder="Type your message"
              className="flex-grow p-2 border rounded-l-lg focus:outline-none"
            />
            <button className="bg-blue-600 text-white p-2 rounded-r-lg">Send</button>
          </div>
        </div>
      )}
      </div>

      
    </div>
    </>
    
  );
};

export default DigitalMarketing;

